import React from "react";
import PageDirection from "components/PageDirection";
import PageTitle from "components/PageTitle";
import { titleTranslation } from "data/services/translationServices";
import { useLanguagesContext } from "hooks/useContextAll";
import ListOfServices from "./ListOfServices";
import ListOfWhyMe from "./ListOfWhyMe";

const ServicesView = () => {
    const language = useLanguagesContext();

    return (
        <>
            <PageTitle text={titleTranslation[language.language]} />
            <PageDirection>
                <ListOfServices language={language} />
                <ListOfWhyMe language={language} />
            </PageDirection>
        </>
    );
};

export default ServicesView;
